import { render } from "./LogOff.vue?vue&type=template&id=52844f26"
import script from "./LogOff.vue?vue&type=script&lang=js"
export * from "./LogOff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__